<template>
  <div class="profile">
    Profile
    <button @click="showUrbanModal">
      Request 열기
    </button>
  </div>
</template>
<script>
import * as types from '../../store/mutation-types'
export default {
  name: 'profile',
  methods: {
    showUrbanModal() {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: 'requestPage',
        active: true,
        type: 'box'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.profile {
  width: 100%;
  height: 100%;
}
</style>
